"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dragCards = exports.clickCards = exports.droppingCardFunc = exports.dropCards = void 0;
function dropCards(e) {
    const target = e.target;
    target.classList.remove('dragging');
}
exports.dropCards = dropCards;
function dragOver(e) {
    var _a;
    e.preventDefault();
    const source = document.getElementById('source-data-block');
    const activeElement = document.getElementsByClassName('dragging')[0];
    const output = document.getElementById('current-output');
    const checkButton = document.getElementById('check-level-button');
    const buttonAutoComplete = document.getElementById('auto-complete-button');
    const target = e.target;
    if (target.id === 'current-output') {
        output.append(activeElement);
        if (!source.hasChildNodes()) {
            checkButton.classList.remove('disabled');
            buttonAutoComplete.classList.add('disabled');
        }
    }
    if (target.id === 'source-data-block') {
        source.append(activeElement);
        if (source.hasChildNodes()) {
            checkButton.classList.add('disabled');
            buttonAutoComplete.classList.remove('disabled');
        }
    }
    (_a = e.dataTransfer) === null || _a === void 0 ? void 0 : _a.clearData();
}
function droppingCardFunc() {
    const droppingArea = document.getElementById('current-output');
    const sourceArea = document.getElementById('source-data-block');
    droppingArea.addEventListener('dragover', dragOver);
    sourceArea.addEventListener('dragover', dragOver);
}
exports.droppingCardFunc = droppingCardFunc;
function clickCards(e) {
    const target = e.target;
    const source = document.getElementById('source-data-block');
    const output = document.getElementById('current-output');
    const checkButton = document.getElementById('check-level-button');
    const buttonAutoComplete = document.getElementById('auto-complete-button');
    if (target.parentNode === output) {
        target.classList.add('word-p-active');
        source.append(target);
        target.classList.remove('word-p-wrong');
        checkButton.classList.add('disabled');
        buttonAutoComplete.classList.remove('disabled');
    }
    else {
        target.classList.add('word-p-active');
        output.append(target);
        if (!source.hasChildNodes()) {
            checkButton.classList.remove('disabled');
            buttonAutoComplete.classList.add('disabled');
        }
    }
    target.classList.remove('word-p-active');
}
exports.clickCards = clickCards;
function dragCards(e) {
    const target = e.target;
    target.classList.add('dragging');
    droppingCardFunc();
}
exports.dragCards = dragCards;
